import { CustomFieldModel } from "../document/custom-field-model";
import { CustomFieldSubGroupModel } from "./custom-field-sub-group.model";

export class CustomFieldGroupModel{
    groupName: string = "Details";
    group: CustomFieldModel[] = [];
    subgroups: CustomFieldSubGroupModel[] = [];
}